import { render, staticRenderFns } from "./AchievementList.vue?vue&type=template&id=b3d79eec&scoped=true&"
import script from "./AchievementList.vue?vue&type=script&lang=js&"
export * from "./AchievementList.vue?vue&type=script&lang=js&"
import style0 from "./AchievementList.vue?vue&type=style&index=0&id=b3d79eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d79eec",
  null
  
)

export default component.exports